import DataLoader from 'dataloader';
import { batchGetHistoricalPropertyDataPoints } from './batchGetHistoricalPropertyDataPoints';
import { batchGetAggregatedPropertyDataPoints } from './batchGetAggregatedPropertyDataPoints';
import { batchGetLatestPropertyDataPoints } from './batchGetLatestPropertyDataPoints';
export class SiteWiseClient {
    constructor(siteWiseSdk, settings = {}) {
        this.siteWiseSdk = siteWiseSdk;
        this.settings = settings;
        /**
         * Instantiate batch data loaders for latest, historical, and aggregated data.
         * by default, data loaders will schedule batches for each frame of execution which ensures
         * no additional latency when capturing many related requests in a single batch.
         */
        this.latestPropertyDataLoader = new DataLoader(async (keys) => {
            batchGetLatestPropertyDataPoints({
                params: keys.flat(),
                client: this.siteWiseSdk,
            });
            return keys.map(() => undefined); // values are updated in data cache and don't need to be rebroadcast
        }, {
            batchScheduleFn: this.settings.batchDuration
                ? (callback) => setTimeout(callback, this.settings.batchDuration)
                : undefined,
        });
        this.historicalPropertyDataLoader = new DataLoader(async (keys) => {
            batchGetHistoricalPropertyDataPoints({
                params: keys.flat(),
                client: this.siteWiseSdk,
            });
            return keys.map(() => undefined);
        }, {
            batchScheduleFn: this.settings.batchDuration
                ? (callback) => setTimeout(callback, this.settings.batchDuration)
                : undefined,
        });
        this.aggregatedPropertyDataLoader = new DataLoader(async (keys) => {
            batchGetAggregatedPropertyDataPoints({
                params: keys.flat(),
                client: this.siteWiseSdk,
            });
            return keys.map(() => undefined);
        }, {
            batchScheduleFn: this.settings.batchDuration
                ? (callback) => setTimeout(callback, this.settings.batchDuration)
                : undefined,
        });
    }
    getLatestPropertyDataPoint(params) {
        return this.latestPropertyDataLoader.load(params);
    }
    getHistoricalPropertyDataPoints(params) {
        return this.historicalPropertyDataLoader.load(params);
    }
    getAggregatedPropertyDataPoints(params) {
        return this.aggregatedPropertyDataLoader.load(params);
    }
}
